import React, { useState } from "react";
import "../Css/AddOnMdal.css";
import { handleError } from "../../CommonJquery/CommonJquery";

const AddOnModal = ({
  isOpen,
  onClose,
  onCloseSave,
  item,
  selectedfoodItemsVari,
  selectedfoodItemsAddon,
  selectedfoodItemsAddonitem,
  selectedfoodItemsAddonVari,
  selectedfoodItemsAddonitemcombo,
}) => {
  //console.log("select data  Add Item Variend", selectedfoodItemsAddonVari);
  //console.log("select data  Add Item Combo", selectedfoodItemsAddonitemcombo);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState({});
  const [total, setTotal] = useState(0);

  const handleVariationSelect = (variation) => {
    setSelectedVariation(variation);
    calculateTotal(variation, selectedAddons);
  };

  const calculateTotal = (selectedVariationsss, newAddons) => {
    let sum =
      parseFloat(selectedVariationsss?.variation_price) ||
      parseFloat(item?.item_original_price);

    Object.entries(newAddons).forEach(([index, items]) => {
      if (items.addon_item_price) {
        sum += parseFloat(items.addon_item_price) * items.quantity;
      }
    });
    if (sum) {
      setTotal(sum);
    }
  };

  const handleAddonSelect = (addon, group) => {
    setSelectedAddons((prevAddons) => {
      let newAddons = Array.isArray(prevAddons) ? [...prevAddons] : [];

      // Check if the addon is already selected
      const existingAddonIndex = newAddons.findIndex(
        (a) => a.primary_id === addon.primary_id
      );

      if (existingAddonIndex !== -1) {
        // If already selected, remove it (Unselect)
        newAddons.splice(existingAddonIndex, 1);
      } else {
        // Otherwise, remove previous selection from the same group and add new one
        newAddons = newAddons.filter((a) => a.group_name !== group.addon_name);
        newAddons.push({
          ...addon,
          quantity: 1,
          group_name: group.addon_name, // Just for reference
        });
      }

      calculateTotal(selectedVariation, newAddons);
      return newAddons;
    });
  };

  const handleSave = () => {
    if (selectedfoodItemsVari && selectedfoodItemsVari.length > 0) {
      console.log(selectedVariation);
      if (!selectedVariation || selectedVariation == null) {
        handleError("Please select variation");
        return;
      }
    }
    let total_amount = parseFloat(total);
    if (total_amount < 1) {
      total_amount = item?.item_original_price;
    }
    const cartItem = {
      item: item,
      selectedVariation: selectedVariation,
      selectedAddons: selectedAddons,
      total_amount: total_amount,
    };
    onCloseSave(cartItem);
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontSize: "16px" }}>
              {item?.item_name || "Tor Pizza"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            {selectedfoodItemsVari && selectedfoodItemsVari.length > 0 && (
              <>
                <div className="mb-4">
                  <h6 className="mb-3" style={{ fontSize: "14px" }}>
                    Variation
                  </h6>
                  <div className="d-flex gap-2">
                    {selectedfoodItemsVari.map((variation, index) => (
                      <button
                        key={index}
                        onClick={() => handleVariationSelect(variation)}
                        className="btn"
                        style={{
                          minWidth: "80px",
                          backgroundColor:
                            selectedVariation?.primary_id ===
                            variation.primary_id
                              ? "#2596be"
                              : "#f8f9fa",
                          color:
                            selectedVariation?.primary_id ===
                            variation.primary_id
                              ? "white"
                              : "black",
                          border: "1px solid #dee2e6",
                        }}
                      >
                        {variation.variation_name}
                        <div className="small">
                          ₹{variation.variation_price}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}

            {/* <div className="mb-4">
              <input
                type="text"
                placeholder="Search addon item"
                className="form-control"
              />
            </div> */}

            {/* Addon Groups */}
            {selectedfoodItemsAddon.map((item, index) => (
              <div key={index} className="mb-4">
                <h6
                  className="text-capitalize mb-3"
                  style={{ fontSize: "14px" }}
                >
                  {item.addon_name}
                </h6>
                <div className="row g-3">
                  {selectedfoodItemsAddonitem
                    .filter(
                      (itemsss) => itemsss.addon_cat_id === item.primary_id
                    )
                    .map((addon, indddddd) => {
                      // const isSelected = false;
                      const isSelected = Object.values(selectedAddons)
                        .flat()
                        .some((a) => a.primary_id === addon.primary_id);

                      return (
                        <div key={indddddd} className="col-md-4">
                          <div
                            className={`addon-card ${
                              isSelected ? "selected" : ""
                            }`}
                            onClick={() => handleAddonSelect(addon, item)}
                            style={{
                              cursor: "pointer",
                              border: `1px solid ${
                                isSelected ? "#198754" : "#dee2e6"
                              }`,
                              borderRadius: "4px",
                              padding: "10px",
                              position: "relative",
                            }}
                          >
                            <div
                              style={{ fontSize: "14px" }}
                              className="fw-medium"
                            >
                              {addon.addon_item_name}
                            </div>
                            <div style={{ fontSize: "12px" }} className="mb-2">
                              ₹{addon.addon_item_price}
                            </div>
                            {isSelected && (
                              <div
                                className="selected-indicator"
                                style={{
                                  position: "absolute",
                                  top: "-8px",
                                  right: "-8px",
                                  background: "#198754",
                                  color: "white",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "12px",
                                }}
                              >
                                ✓
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            ))}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div className="fw-medium">₹ {total}</div>
            <div>
              <button
                onClick={onClose}
                className="btn btn-outline-secondary me-2"
                style={{ fontSize: "14px" }}
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="btn action-save"
                style={{ fontSize: "14px", color: "#fff" }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOnModal;
